/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedWorkDTO } from './ReferencedWorkDTO';
import {
    ReferencedWorkDTOFromJSON,
    ReferencedWorkDTOFromJSONTyped,
    ReferencedWorkDTOToJSON,
    ReferencedWorkDTOToJSONTyped,
} from './ReferencedWorkDTO';

/**
 * 
 * @export
 * @interface WorkHasPartDTO
 */
export interface WorkHasPartDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkHasPartDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkHasPartDTO
     */
    articleId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHasPartDTO
     */
    issue?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHasPartDTO
     */
    pageFirst?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHasPartDTO
     */
    pageLast?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkHasPartDTO
     */
    volume?: string;
    /**
     * 
     * @type {ReferencedWorkDTO}
     * @memberof WorkHasPartDTO
     */
    referencedWork?: ReferencedWorkDTO;
}

/**
 * Check if a given object implements the WorkHasPartDTO interface.
 */
export function instanceOfWorkHasPartDTO(value: object): value is WorkHasPartDTO {
    return true;
}

export function WorkHasPartDTOFromJSON(json: any): WorkHasPartDTO {
    return WorkHasPartDTOFromJSONTyped(json, false);
}

export function WorkHasPartDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkHasPartDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'articleId': json['articleId'] == null ? undefined : json['articleId'],
                  'issue': json['issue'] == null ? undefined : json['issue'],
                  'pageFirst': json['pageFirst'] == null ? undefined : json['pageFirst'],
                  'pageLast': json['pageLast'] == null ? undefined : json['pageLast'],
                  'volume': json['volume'] == null ? undefined : json['volume'],
                  'referencedWork': json['referencedWork'] == null ? undefined : ReferencedWorkDTOFromJSON(json['referencedWork']),
    };
}

export function WorkHasPartDTOToJSON(json: any): WorkHasPartDTO {
    return WorkHasPartDTOToJSONTyped(json, false);
}

export function WorkHasPartDTOToJSONTyped(value?: WorkHasPartDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'articleId': value['articleId'],
        'issue': value['issue'],
        'pageFirst': value['pageFirst'],
        'pageLast': value['pageLast'],
        'volume': value['volume'],
        'referencedWork': ReferencedWorkDTOToJSON(value['referencedWork']),
    };
}


